import './ExplorerTreeSkeleton.css'

export default function ExplorerTreeSkeleton() {
  const items = [1, 2, 3]

  return (
    <nav className="data-explorer skeleton">
      <ul>
        {items.map((i) => (
          <li key={`cat-${i}`}>
            <div className="icon icon-angle-right" />
            <div className="skeleton-pulse text" />
          </li>
        ))}
      </ul>
    </nav>
  )
}
